import { AuditableEntity } from "./audible-entity.model";
import { ContractBase } from "./contract-base.model";
import { DeliveryAddress } from "./delivery-address.model";
import { FacilityType } from "./facility-type.model";

export class Customer extends AuditableEntity {
    constructor(_id?: number, _facilityTypeId?: number, _city?: string, _btw?: string, _company?: string, _customerType?: string, _description?: string, _userId?: string,
        _email?: string, _houseNumber?: string, _busNumber?: string, _isActive?: boolean, _name?: string, _groupName?: string, _phoneNumber?: string, _postalCode?: string, _street?: string,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date, _DeletedBy?: string, _DeletedDate?: Date, _customerRegistrationType?: string) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _id;
        this.FacilityTypeId = _facilityTypeId;
        this.Street = _street;
        this.City = _city;
        this.Email = _email;
        this.Name = _name;
        this.GroupName = _groupName;
        this.PhoneNumber = _phoneNumber;
        this.BTW = _btw;
        this.Company = _company;
        this.CustomerType = _customerType || "Group";
        this.Description = _description;
        this.HouseNumber = _houseNumber;
        this.BusNumber = _busNumber;
        this.IsActive = _isActive || true;
        this.PostalCode = _postalCode;
        this.UserID = _userId;
        this.CustomerRegistrationType = _customerRegistrationType || 'B';

        this.FacilityType = new FacilityType();
        this.ContractBases = new Array<ContractBase>();
        this.DeliveryAddresses = new Array<DeliveryAddress>();
    }

    public Id: number;
    public FacilityTypeId: number;
    public Street: string;
    public City: string;
    public Email: string;
    public Name: string;
    public GroupName: string;
    public PhoneNumber: string;
    public BusNumber: string;
    public BTW: string;
    public Company: string;
    public CustomerType: string;
    public Description: string;
    public HouseNumber: string;
    public IsActive: boolean;
    public PostalCode: string;
    public UserID: string;
    public CustomerRegistrationType: string = 'B';

    public FacilityType: FacilityType;
    public ContractBases: ContractBase[];
    public DeliveryAddresses: DeliveryAddress[];
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/customer.model.ts